module.exports = __webpack_public_path__ + "static/img/yy.auth.f6fc13f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yy.auth.png
// module id = 1303
// module chunks = 382